import { render, staticRenderFns } from "./ReturnBackOnHold.vue?vue&type=template&id=702c23d0&scoped=true"
import script from "./ReturnBackOnHold.vue?vue&type=script&lang=js"
export * from "./ReturnBackOnHold.vue?vue&type=script&lang=js"
import style0 from "./ReturnBackOnHold.vue?vue&type=style&index=0&id=702c23d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "702c23d0",
  null
  
)

export default component.exports